import { CoreIcon } from '../core-icon';
import closeCircleSVG from '../../assets/icons/close-circle.svg';
import type { IconProps } from '../core-icon';

export const CloseCircleIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={closeCircleSVG} {...props} />;
};
